//Function to extract an object based on a string as query parameter

export default function (obj, path) {
    return path
        .split('.') //Convert the string in array
        .reduce((prevValue, currentValue) => {
            return prevValue[currentValue] //map the new Array, getting in each cycle the object filtered 
        }, obj)
}